export const Content = {
  aboutContentOne:
    'Clamor is an online food ordering platform that allows users to browse available restaurants in their area and directly place food orders for pickup and dine-in. We aim to provide customers with a friendly and inviting space where they can discover new foods, learn about trending items and restaurants in their area, and earn perks. Some exciting new features in our roadmap will include check-splitting, multi-restaurant ordering, joining waitlists, and more!',
  aboutContentTwo:
    'For restaurants, our platform is simple and efficient, reducing the workload on your staff while providing high-value tools. Leveraging the trust and reputation of Stripe, our point-of-sale system prioritizes transparency, security, and scalability for your business. Some exciting features on our roadmap include analytics on your menu performance, data-driven insights to stay on top of trends, and rewards programs to build loyalty with your customer base.',
};

export const PolicyContent = {
  policyOne:
    'Thank you for using Clamor (the Service). This Privacy Policy explains how we collect, use, and protect your personal information when you use our Service.',
};

export const orderStatusText = ['Rate the Food Quality', 'Rate the Service', 'Rate the App'];

export const reasonCause = [
  {
    label: 'I found a better quality',
    value: '1',
  },
  {
    label: 'I found better price',
    value: '2',
  },
  {
    label: 'I do not want this item',
    value: '3',
  },
  {
    label: 'Other',
    value: '7',
  },
];
